export default __webpack_public_path__ + "static/media/Foto8.2e0e9c42.png";